export default __webpack_public_path__ + "static/media/Scientists_Row-2.74fb5ea6.png";